export const mapAutoYear = (year: number) => ({ value: year, label: year.toString() });
